// Callbacks only. Each editor retains its own content and persistence authority.
const owners = new Set();
export function registerMediaSaveGuard(owner) {
  owners.add(owner);
  return () => owners.delete(owner);
}
export function hasMediaDraft() { return [...owners].some(owner => owner.isDirty()); }
export async function flushMediaDrafts() {
  for (const owner of [...owners]) {
    if (!owner.isDirty()) continue;
    try { if (!await owner.flush()) return false; } catch { return false; }
  }
  return !hasMediaDraft();
}
